import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Lottie from "lottie-react";
import LottieViewer from '../../../../components/LottieViewer';

const info = {
  title: "Financial insights, tools and systems that empower lenders and businesses to be.",
  description: "Mitigate credit losses, discover business opportunities and grow with the right set of customers",
  path: `${process.env.REACT_APP_CDN_URL}/assets/lottie/public-home/home-banner.json`,
  signUpUrl:'https://account.crediwatch.com/signup',
  demoUrl: `https://about.crediwatch.com/contact/request-a-demo/`
}

const MainSection = () => {
  
  return (
    <>
        <div className='row flex-md-row-reverse'>
          <div className='col-lg-5 col-12 mt-4'>
            <div className='d-flex align-items-center justify-content-center h-100'>
              <LottieViewer location_path={info.path} />
            </div>
          </div>
          <div className='col-lg-1 d-none d-lg-block'>
          </div>
          <div className='col-lg-6 col-12 d-flex flex-column justify-content-center mt-4'>
            <h1 className='title mb-4 ff-renner-book'> {info.title}</h1>
            <h5 className='titleInfo mb-4 ff-renner-light'>{info.description}</h5>
            <div>
              <button className='cw-btn cw-btn-primary ff-renner-book' onClick={() => window.open(info.signUpUrl,"_self")}>Sign Up</button>
              <button className='ml-3 cw-btn cw-btn-secondary ff-renner-book' onClick={() => window.open(info.demoUrl,"_self")}>Book a Demo</button>
            </div>
          </div>
        </div>
    </>
  )
}
export default MainSection